export default __webpack_public_path__ + "static/get-new-car-image-3-9882bf560f1a894a2e7f05f18662f05d.jpg";